import firebase from '../firebase/config'

export default (uid) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_DATA_LOADING' })
        try {
            firebase.database().ref(`users/${uid}/vaults`).once('value', function (snapshot) {
                if (snapshot.val()) {
                    let vaults = Object.keys(snapshot.val())
                    dispatch({ type: 'FETCH_DATA_SUCCESS', payload: vaults })
                } else {
                    dispatch({ type: 'FETCH_DATA_SUCCESS', payload: [] })
                }
            })
        } catch (error) {
            dispatch({ type: 'FETCH_DATA_ERROR' })
        }
    }
}